/**
 * A smaller subset of components used by the public_pages, used to avoid to load unused code in the public_pages
 *
 * @author Simone Sacchi
 * @version 2025/09/29
 * */
module.exports = {
    components: {
        banner: require("src/components/banner"),
        button: require("src/components/button"),

        dropdown: require("src/components/dropdown"),
        header: require("src/components/header"),
        icon: require("src/components/icon"),
        link: require("src/components/link"),
        // table: require("src/components/table"),
        tabs: require("src/components/tabs"),
        tooltip: require("src/components/tooltip"),
        input: require("src/components/form/input"),
        nav_toggle: require("src/components/nav_toggle"),
        inline_message: require("src/components/inline_message"),
        pagination: require("src/components/pagination"),
        dialog: require("src/components/dialog"),
        checkbox: require("src/components/form/checkbox")
    },
    tokens: {
        index: require("src/tokens/index.css"),
        shared_components_style: require("src/tokens/shared_components_style_public_pages.css")
    },
    foundation: {
        logos: {
            swift_dark_green: require("src/foundations/logos/Swift_Logo_RGB_Dark_Green.svg"),
            swift_peppermint: require("src/foundations/logos/Swift_Logo_RGB_Peppermint.svg"),
            swift_white: require("src/foundations/logos/Swift_Logo_RGB_White.svg")
        }
    }
};

// a function to list all the swiftref-* in the page
// function getMyCustomComponents(prefix = 'swiftref-') {
//     return Array.from(
//         new Set(
//             Array.from(document.querySelectorAll('*'))
//                 .filter(el => el.tagName.toLowerCase().startsWith(prefix))
//                 .map(el => el.tagName.toLowerCase())
//         )
//     );
// }

